module.exports = __webpack_public_path__ + "img/cookie-500.ede975e1.jpeg";